import * as React from 'react'

import Button                  from '@material-ui/core/Button'
import Grid                    from '@material-ui/core/Grid'
import { InjectedFormikProps } from 'formik'
import { FormattedMessage }    from 'react-intl'

const submissionBubblingProxy = (handler: any) => {
  return (
    (e: any) => {
      e.stopPropagation()
      handler(e)
    }
  )
}

interface Props<PassedProps, Fields> {
  children: (props: InjectedFormikProps<PassedProps, Fields>) => JSX.Element
}

type nestedFormWrapperComponent =
  <Fields, PassedProps = {}>(props: InjectedFormikProps<
    PassedProps
  & Props<PassedProps, Fields
  >, Fields>) => JSX.Element

const NestedFormWrapper: nestedFormWrapperComponent = props => {
  const { handleSubmit, children } = props

  return (
    <form onSubmit={submissionBubblingProxy(handleSubmit)}>
      <Grid container spacing={16}>
        <Grid item xs={12}>
          {children(props)}
        </Grid>
        <Grid item container justify={'flex-end'}>
          <Button
            variant={'raised'}
            color={'primary'}
            type={'submit'}
          >
            <FormattedMessage
              id={'buttonActions.save'}
              defaultMessage={'save'}
            />
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default NestedFormWrapper



// WEBPACK FOOTER //
// ./src/components/forms/wrappers/NestedFormWrapper.tsx